
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressInsuranceEN]",
      function () {
        return require("private-next-pages/[...wordpressInsuranceEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressInsuranceEN]"])
      });
    }
  